import fileExporter from './FileExporter'

function textFileExporter(name, text) {
  text = text || '';
  name = name || 'Untitled'
  fileExporter(name + '.txt', text);
}

export default textFileExporter
